import { useMemo } from 'react';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Step, StepLabel, Stepper } from '@mui/material';

export interface AddPromotionStepperFCProps {
  strings: {
    type: string;
    details: string;
    review: string;
  };
  currentStep: 0 | 1 | 2;
}

const Connector = () => (
  <Box display="flex" justifyContent="flex-end" paddingRight={2} paddingLeft={2}>
    <KeyboardArrowRightIcon />
  </Box>
);

export const AddPromotionStepperFC = (props: AddPromotionStepperFCProps) => {
  const { strings, currentStep } = props;

  const steps = useMemo(
    () =>
      Object.entries(strings).map(([key, value], index) => (
        <Step key={key}>
          <StepLabel
            sx={{
              color: 'colors.neutral300',
              fontWeight: 600,
              fill: index === currentStep ? 'colors.white' : 'colors.neutral700',
            }}
          >
            {value}
          </StepLabel>
        </Step>
      )),
    [currentStep, strings],
  );

  return (
    <Stepper nonLinear activeStep={currentStep} connector={<Connector />} sx={{ py: 4, px: 0 }}>
      {steps}
    </Stepper>
  );
};
